export const getSubscriptionPlanByInterval = (interval) => (state) =>
  state.payment.subscriptionPlans.find((plan) => plan.interval === interval && !plan.zppCertified) ?? {};
